import React from 'react'

const LogOut = () => {
    React.useEffect(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        window.location.href = '/'
    })

    return (
        <div></div>
    )
}

export default LogOut